import React from "react";
import NavigationBar from "../common/NavigationBar";
import AboutSection from "../components/AboutSection";
import WhyChooseSection from "../components/WhyChooseSection";
import TestiMonials from "../components/TestiMonials";
import ContactSection from "../common/ContactAs";
import background from "../assets/bg-shape-1.png";

const AboutUs = React.forwardRef((_, ref) => {
  return (
    <div id="aboutus" className="aboutus-container" ref={ref}>
       <div className="aboutus-top-bar">
        <NavigationBar />
      </div>
      <div className="aboutus-header">
        <h1 className="aboutus-title-h1">About Right Lender</h1>
        <p className="aboutus-title-p">Crafting immersive digital journeys for brands.</p>
      </div>
      <div className="aboutus-gallery-content">
        <AboutSection/>
      </div>
      <div className="aboutus-why-choosen">
        <WhyChooseSection/>
      </div>
      <div className="aboutus-TestiMonials">
        <TestiMonials/>
      </div>
      <div className="aboutus-Contactas">
        <ContactSection/>
      </div>
    </div>
  );
});

export default AboutUs;
